export default __webpack_public_path__ + "static/media/ic_eye_fill.bb5a4e6f.svg";